var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_774_7876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#3474E0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_774_7876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 10.6667C8.83342 10.6667 9.54175 10.3751 10.1251 9.79175C10.7084 9.20842 11.0001 8.50008 11.0001 7.66675C11.0001 6.83342 10.7084 6.12508 10.1251 5.54175C9.54175 4.95841 8.83342 4.66675 8.00008 4.66675C7.16675 4.66675 6.45842 4.95841 5.87508 5.54175C5.29175 6.12508 5.00008 6.83342 5.00008 7.66675C5.00008 8.50008 5.29175 9.20842 5.87508 9.79175C6.45842 10.3751 7.16675 10.6667 8.00008 10.6667ZM8.00008 9.46675C7.50008 9.46675 7.07508 9.29175 6.72508 8.94175C6.37508 8.59175 6.20008 8.16675 6.20008 7.66675C6.20008 7.16675 6.37508 6.74175 6.72508 6.39175C7.07508 6.04175 7.50008 5.86675 8.00008 5.86675C8.50008 5.86675 8.92508 6.04175 9.27508 6.39175C9.62508 6.74175 9.80008 7.16675 9.80008 7.66675C9.80008 8.16675 9.62508 8.59175 9.27508 8.94175C8.92508 9.29175 8.50008 9.46675 8.00008 9.46675ZM8.00008 12.6667C6.37786 12.6667 4.90008 12.214 3.56675 11.3084C2.23341 10.4029 1.26675 9.18897 0.666748 7.66675C1.26675 6.14453 2.23341 4.93064 3.56675 4.02508C4.90008 3.11953 6.37786 2.66675 8.00008 2.66675C9.6223 2.66675 11.1001 3.11953 12.4334 4.02508C13.7667 4.93064 14.7334 6.14453 15.3334 7.66675C14.7334 9.18897 13.7667 10.4029 12.4334 11.3084C11.1001 12.214 9.6223 12.6667 8.00008 12.6667ZM8.00008 11.3334C9.25564 11.3334 10.4084 11.0029 11.4584 10.3417C12.5084 9.68064 13.3112 8.78897 13.8667 7.66675C13.3112 6.54453 12.5084 5.65286 11.4584 4.99175C10.4084 4.33064 9.25564 4.00008 8.00008 4.00008C6.74453 4.00008 5.59175 4.33064 4.54175 4.99175C3.49175 5.65286 2.68897 6.54453 2.13341 7.66675C2.68897 8.78897 3.49175 9.68064 4.54175 10.3417C5.59175 11.0029 6.74453 11.3334 8.00008 11.3334Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.c9c3555ac4e931ba0cc6609f2eb14da6.svg";
export { ForwardRef as ReactComponent };